import {
  Dialog,
  DialogActions,
  DialogContent,
  Divider,
  Grid,
  makeStyles,
} from '@material-ui/core';
import Button from 'components/Button/Button';
import DialogHeader from 'components/DialogHeader/DialogHeader';
import Loading from 'components/Loading/Loading';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { setIsJydacomAssignmentsDialogOpen } from 'store/assignments/actions/assignments.actions';
import {
  selectAssignmentJydacomInfoModifications,
  selectIsLoadingJydacomAssignments,
  selectIsUpdatingAssignments,
  selectProjectAssignmentsTree,
  selectProjectJydacomAssignments,
} from 'store/assignments/selectors/assignment.selectors';
import { loadJydacomAssignmentsOfProject } from 'store/assignments/thunks/loadJydacomAssignmentsOfProject.thunk';
import { saveAssignmentJydacomInfoModifications } from 'store/assignments/thunks/saveAssignmentJydacomInfoModifications.thunk';
import { AssignmentCounterpartSelectItem } from './AssignmentCounterpartSelectItem/AssignmentCounterpartSelectItem';

export const JydacomAssignmentsDialog = ({
  projectId,
  onClose,
  onSaveComplete,
}) => {
  const useStyles = makeStyles((theme) => ({
    dialogPaper: {
      ...theme.component.dialogPaper,
      [theme.breakpoints.down('xs')]: {
        ...theme.component.dialogPaperFullscreen,
      },
    },
    dialogContent: {
      paddingTop: theme.spacing(2),
    },
    dialogActions: {
      paddingLeft: theme.spacing(1.5),
      paddingRight: theme.spacing(1.5),
    },
  }));

  const { t } = useTranslation('common');

  const classes = useStyles();

  const dispatch = useDispatch();

  const handleClose = () => {
    if (onClose) {
      onClose();
    } else {
      dispatch(setIsJydacomAssignmentsDialogOpen(false));
    }
  };

  const onSave = async () => {
    await dispatch(saveAssignmentJydacomInfoModifications(projectId));
    if (onSaveComplete) {
      onSaveComplete();
    }
  };

  useEffect(() => {
    dispatch(loadJydacomAssignmentsOfProject(projectId));
  }, []);

  const isLoadingJydacomAssignments = useSelector(
    selectIsLoadingJydacomAssignments
  );

  const jydacomAssignmentsOptions = useSelector((state) =>
    selectProjectJydacomAssignments(state, projectId)
  );

  const projectAssignments = useSelector((state) =>
    selectProjectAssignmentsTree(state, projectId)
  );

  const jydacomAssignmentModifications = useSelector(
    selectAssignmentJydacomInfoModifications
  );

  const isUpdatingAssignments = useSelector(selectIsUpdatingAssignments);

  const AssignmentLevel = ({ assignment, padding }) => {
    return (
      <div
        style={{
          width: '100%',
          paddingLeft: `${padding}px`,
        }}
      >
        {assignment.children && assignment.children.length > 0 ? (
          <div key={assignment.id} style={{ width: '100%' }}>
            <p>{`${assignment.number}. ${assignment.name}`}</p>
            {assignment.children
              .sort((a, b) => a.number - b.number)
              .map((assignment) => (
                <AssignmentLevel
                  assignment={assignment}
                  key={assignment.id}
                  padding={padding}
                ></AssignmentLevel>
              ))}
          </div>
        ) : (
          <AssignmentCounterpartSelectItem
            key={assignment.id}
            assignment={{
              ...assignment,
              ...jydacomAssignmentModifications[assignment.id],
            }}
            jydacomAssignmentOptions={jydacomAssignmentsOptions}
          ></AssignmentCounterpartSelectItem>
        )}
      </div>
    );
  };

  return (
    <Dialog
      classes={{ paper: classes.dialogPaper }}
      fullWidth
      maxWidth="xs"
      open={true}
    >
      <DialogHeader
        title={'Jydacom litteroiden yhdistäminen'}
        onClose={handleClose}
      />
      <DialogContent className={classes.dialogContent}>
        {!isLoadingJydacomAssignments ? (
          jydacomAssignmentsOptions && jydacomAssignmentsOptions.length > 0 ? (
            <Grid container>
              {projectAssignments
                .sort((a, b) => a.number - b.number)
                .map((assignment) => (
                  <div
                    key={assignment.id}
                    style={{
                      backgroundColor: 'rgb(0, 90, 127)',
                      marginBottom: '10px',
                      width: '100%',
                    }}
                  >
                    <AssignmentLevel
                      assignment={assignment}
                      padding={10}
                    ></AssignmentLevel>
                  </div>
                ))}
            </Grid>
          ) : (
            <div>Jydacom litteroita ei löytynyt projektille</div>
          )
        ) : (
          <Loading tiny></Loading>
        )}
        <Divider />
      </DialogContent>
      <DialogActions className={classes.dialogActions}>
        <Button onClick={handleClose}>{t('common.cancel')}</Button>
        <Button
          onClick={onSave}
          elevated
          disabled={
            !Object.values(jydacomAssignmentModifications).length > 0 ||
            isUpdatingAssignments
          }
        >
          {isUpdatingAssignments ? <Loading tiny></Loading> : t('common.save')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
